export default __webpack_public_path__ + "static/media/emp-sys.924d4485.png";